import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=993000ca"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=993000ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports